module.exports = __webpack_public_path__ + "fonts/K88pR3goAWT7BTt32Z01m4X0hVgzZQUfRDuZrPvH3D8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/K88pR3goAWT7BTt32Z01m4X0hVgzZQUfRDuZrPvH3D8.woff2
// module id = 378
// module chunks = 0